import type { AppNotification } from '../../services/notification';

export type GroupKey = 'today' | 'yesterday' | 'thisWeek' | 'thisMonth' | 'last3Months' | 'older';

export type CategoryBrowserSetting = {
  id: number;
  category: string;
  emailEnabled: boolean;
  browserEnabled: boolean;
  browserMuted: boolean;
};

export const GROUP_ORDER: GroupKey[] = ['today', 'yesterday', 'thisWeek', 'thisMonth', 'last3Months', 'older'];

export function getNotificationGroup(createdAt: string): GroupKey {
  const now = new Date();
  const date = new Date(createdAt);
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterdayStart = new Date(todayStart);
  yesterdayStart.setDate(yesterdayStart.getDate() - 1);
  const daysFromMonday = (now.getDay() + 6) % 7;
  const weekStart = new Date(todayStart);
  weekStart.setDate(weekStart.getDate() - daysFromMonday);
  const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
  const threeMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 3, 1);

  if (date >= todayStart) return 'today';
  if (date >= yesterdayStart) return 'yesterday';
  if (date >= weekStart) return 'thisWeek';
  if (date >= monthStart) return 'thisMonth';
  if (date >= threeMonthsAgo) return 'last3Months';
  return 'older';
}

export function groupNotifications(notifications: AppNotification[]): Partial<Record<GroupKey, AppNotification[]>> {
  const groups: Partial<Record<GroupKey, AppNotification[]>> = {};
  for (const n of notifications) {
    const key = getNotificationGroup(n.createdAt);
    if (!groups[key]) groups[key] = [];
    groups[key]!.push(n);
  }
  return groups;
}
